import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeCircle,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";
import {
  Elements,
  ElementsConsumer,
  ExpressCheckoutElement,
  PaymentElement,
} from "@stripe/react-stripe-js";
import {
  loadStripe,
  StripeExpressCheckoutElementConfirmEvent,
  StripePaymentElementChangeEvent,
} from "@stripe/stripe-js";

const PLNPlusPaymentMethodPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const pageRef = useRef();
  const [stripeEvent, setStripeEvent] = useState<any>(null);
  const [expressCheckoutReady, setExpressCheckoutReady] =
    useState<boolean>(false);
  const [paymentElementReady, setPaymentElementReady] =
    useState<boolean>(false);
  const [stripe, setStripe] = useState<any>(null);
  const [stripeOptions, setStripeOptions] = useState<any>(null);
  const [stripeCustomerID, setStripeCustomerID] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [newUserName, setNewUserName] = useState<any>(null);
  const [newUserEmail, setNewUserEmail] = useState<any>(null);
  const [newUserPhone, setNewUserPhone] = useState<any>(null);
  const [newUserPhoneReadable, setNewUserPhoneReadable] = useState<any>(null);
  const [newUserShippingAddress, setNewUserShippingAddress] =
    useState<any>(null);
  const [newUserBillingAddress, setNewUserBillingAddress] = useState<any>(null);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const paymentErrorTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const [present] = useIonToast();

  const PAYMENT_ERROR_DISPLAY_MS = 7000;

  const showPaymentError = (message: string) => {
    if (paymentErrorTimeoutRef.current) {
      clearTimeout(paymentErrorTimeoutRef.current);
    }

    setPaymentError(message);

    paymentErrorTimeoutRef.current = setTimeout(() => {
      setPaymentError(null);
      paymentErrorTimeoutRef.current = null;
    }, PAYMENT_ERROR_DISPLAY_MS);
  };

  const submit = async () => {
    setSubmitting(true);
  };

  /**
   * Loads the stripe client
   *
   * @param email
   */
  const loadStripeClient = async (email: string = "") => {
    return new Promise(async (resolve) => {
      const st = await loadStripe(Constants.STRIPE_KEY);

      setStripe(st);

      API.getStripeCheckoutIntent(email)
        .then(
          (data: any) => {
            //console.log(data.data);

            let opts: any = _.clone(Constants.STRIPE_DEFAULT_OPTIONS);

            opts.clientSecret = data.data?.data?.clientSecret;

            setStripeOptions(opts);
            setStripeCustomerID(data.data.data.stripeCustomerID);
          },
          (e) => {
            console.error(e);
          },
        )
        .finally(() => {
          resolve(true);
        });
    });
  };

  let loadUser = async () => {
    setLoading(true);

    const user = await StorageUtils.get("user_customer");

    setUser(user);

    const token = await StorageUtils.get("user_authorizationToken");

    API.setAuthToken(token);

    loadStripeClient(user?.email).then(() => {
      setLoading(false);
    });
  };

  const onPaymentMethodSubmit = async (
    e: any = null,
    stripeElements: any = null,
  ) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.

    //console.log(e);

    setSubmitting(true);

    try {
      e.preventDefault();
    } catch (e) {
      //console.error(e);
    }

    if (!stripe) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      const message =
        "We're having trouble processing your credit card: unknown error occurred. Please try again.";

      showPaymentError(message);

      present({
        message,
        duration: 1500,
        position: "bottom",
        icon: closeCircle,
        color: "danger",
        layout: "baseline",
        mode: "ios",
        buttons: [
          {
            text: "OK",
            role: "cancel",
          },
        ],
      });

      setSubmitting(false);

      return;
    }

    let params: any = {
      //`Elements` instance that was used to create the Payment Element
      elements: stripeElements,
      confirmParams: {
        //return_url: window.location.href,
      },
      redirect: "if_required",
    };

    if (e?.elementType != "expressCheckout") {
      params.confirmParams.payment_method_data = {
        billing_details: {
          name: user?.name ? user?.name : user?.customer?.name,
        },
      };
    }

    let result = await stripe.confirmSetup(params);

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error);

      const message =
        "We received the following payment error: " + result.error.message;

      showPaymentError(message);

      present({
        message,
        duration: 1500,
        position: "bottom",
        icon: closeCircle,
        color: "danger",
        layout: "baseline",
        mode: "ios",
        buttons: [
          {
            text: "OK",
            role: "cancel",
          },
        ],
      });

      setSubmitting(false);

      return;
    }

    result.stripeCustomerID = stripeCustomerID;

    let opaqueData = {
      provider: "stripe",
      stripeCustomerID: result?.stripeCustomerID,
      stripePaymentMethod: result?.setupIntent?.payment_method,
    };

    API.updatePaymentMethod(opaqueData)
      .then(
        async (res: any) => {
          const customer = res?.data?.data?.customer;

          user.customer = customer;

          await StorageUtils.set("user_customer", user);

          setUser(user);
          loadUser();

          present({
            message: `Your payment method has been successfully added to your account.`,
            duration: 1500,
            position: "bottom",
            icon: checkmarkCircle,
            color: "success",
            layout: "baseline",
            mode: "ios",
            buttons: [
              {
                text: "OK",
                role: "cancel",
              },
            ],
          });

          next();
        },
        (e: any) => {
          const message =
            "We're having trouble processing your credit card: unknown error occurred. Please try again.";

          showPaymentError(message);

          present({
            message,
            duration: 1500,
            position: "bottom",
            icon: closeCircle,
            color: "danger",
            layout: "baseline",
            mode: "ios",
            buttons: [
              {
                text: "OK",
                role: "cancel",
              },
            ],
          });
        },
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    loadUser();
  }, []);

  useEffect(() => {
    if (!user) {
      console.log("USER", user);

      loadUser();
    }
  }, []);

  useEffect(() => {
    return () => {
      if (paymentErrorTimeoutRef.current) {
        clearTimeout(paymentErrorTimeoutRef.current);
      }
    };
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Payment Information</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Payment Information"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      {loading || !stripeOptions?.clientSecret ? (
        <>
          <IonContent className="bg-white">
            <div className="text-center ion-padding pln-onboarding-container">
              <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
                Add Payment Information
              </h2>
              <p className="" style={{ fontSize: 18 }}>
                We noticed that your membership doesn't have payment information
                set up. Let's get that updated so your first order is a breeze!
              </p>
              <div className="mt-[1rem] mb-[1rem] border-t-[1px] border-gray-100"></div>

              <div>
                <IonSkeletonText
                  style={{ width: "100%", height: 300 }}
                  animated={true}
                ></IonSkeletonText>
              </div>
            </div>
          </IonContent>
          <IonFooter>
            <IonToolbar
              className={`pln-native-toolbar-footer ${
                !Capacitor.isNativePlatform() && "web"
              }`}
            >
              <IonButton
                disabled={true}
                onClick={() => {}}
                expand="block"
                mode={
                  Capacitor.isNativePlatform()
                    ? Capacitor.getPlatform() == "ios"
                      ? "ios"
                      : "md"
                    : "ios"
                }
              >
                {submitting ? (
                  <IonSpinner className="h-[22px]" name="dots"></IonSpinner>
                ) : (
                  "Continue"
                )}
              </IonButton>
            </IonToolbar>
          </IonFooter>
        </>
      ) : (
        <>
          <Elements stripe={stripe} options={stripeOptions}>
            <ElementsConsumer>
              {({ stripe, elements }) => {
                //console.log("STRIPE", stripe);
                //console.log("ELEMENTS", elements);

                return (
                  <>
                    <IonContent className="bg-white">
                      <div className="text-center ion-padding pln-onboarding-container">
                        <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
                          Add Payment Information
                        </h2>
                        <p className="" style={{ fontSize: 18 }}>
                          We noticed that your membership doesn't have payment
                          information set up. Let's get that updated so your
                          first order is a breeze!
                        </p>
                        <div className="mt-[1rem] mb-[1rem] border-t-[1px] border-gray-100"></div>

                        <div>
                          {!Capacitor.isNativePlatform() && (
                            <>
                              {!expressCheckoutReady && (
                                <>
                                  <IonSkeletonText
                                    animated={true}
                                    style={{
                                      width: "100%",
                                      height: 52,
                                      marginTop: -4,
                                      marginBottom: -4,
                                      borderRadius: 6,
                                    }}
                                  ></IonSkeletonText>
                                </>
                              )}
                              <ExpressCheckoutElement
                                className={`pln-expresscheckout ${
                                  expressCheckoutReady && "ready"
                                }`}
                                onReady={() => {
                                  let element: any =
                                    elements?.getElement("expressCheckout");

                                  try {
                                    //console.log(element?._component?.style);

                                    element._component.style.transition = null;
                                  } catch (e) {
                                    console.error(e);
                                  }

                                  setExpressCheckoutReady(true);
                                }}
                                onConfirm={(
                                  event: StripeExpressCheckoutElementConfirmEvent,
                                ) => {
                                  //console.log("confirm", event, this.props.stripe);

                                  let statePayload: any = {
                                    expressCheckout: true,
                                  };

                                  if (event?.billingDetails?.name) {
                                    statePayload.name =
                                      event?.billingDetails?.name;
                                  }

                                  if (event?.billingDetails?.address?.line1) {
                                    statePayload.address1 =
                                      event?.billingDetails?.address.line1;
                                  }

                                  if (event?.billingDetails?.address?.line2) {
                                    statePayload.address2 =
                                      event?.billingDetails?.address.line2;
                                  }

                                  if (event?.billingDetails?.address?.city) {
                                    statePayload.city =
                                      event?.billingDetails?.address.city;
                                  }

                                  if (event?.billingDetails?.address?.state) {
                                    statePayload.state =
                                      event?.billingDetails?.address.state;
                                  }

                                  if (
                                    event?.billingDetails?.address?.postal_code
                                  ) {
                                    statePayload.zipCode =
                                      event?.billingDetails?.address.postal_code;
                                  }

                                  onPaymentMethodSubmit(event, elements);

                                  /*this.setState(statePayload, () => {
                              this.handleSubmit(event);
                            });*/

                                  //this.state.stripe.confirmPayment();

                                  //this.state.stripe.getCardToken();
                                }}
                              ></ExpressCheckoutElement>
                            </>
                          )}
                          <div>
                            <div style={{ width: "100%" }}>
                              {paymentError && (
                                <div
                                  className="mt-2 mb-2 text-left text-sm font-medium rounded-md px-3 py-2"
                                  style={{
                                    color: "var(--ion-color-danger)",
                                    backgroundColor:
                                      "rgba(var(--ion-color-danger-rgb), 0.08)",
                                    border:
                                      "1px solid rgba(var(--ion-color-danger-rgb), 0.25)",
                                  }}
                                  role="alert"
                                >
                                  {paymentError}
                                </div>
                              )}
                              {!paymentElementReady && (
                                <>
                                  <IonSkeletonText
                                    className="mt-2"
                                    animated={true}
                                    style={{
                                      width: "100%",
                                      height: 320,
                                      marginTop: -4,
                                      marginBottom: -4,
                                      borderRadius: 6,
                                    }}
                                  ></IonSkeletonText>
                                </>
                              )}
                              <PaymentElement
                                className="mt-2"
                                onReady={() => {
                                  //console.log("STRIPE READY");
                                }}
                                onChange={(
                                  event: StripePaymentElementChangeEvent,
                                ) => {
                                  setStripeEvent(event);
                                }}
                                onLoaderStart={() => {
                                  setPaymentElementReady(true);
                                }}
                                options={{
                                  layout: {
                                    type: "accordion",
                                  },

                                  wallets: {
                                    applePay: "never",
                                    googlePay: "never",
                                  },
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </IonContent>
                    <IonFooter>
                      <IonToolbar
                        className={`pln-native-toolbar-footer ${
                          !Capacitor.isNativePlatform() && "web"
                        }`}
                      >
                        <IonButton
                          disabled={submitting || !stripeEvent?.complete}
                          onClick={() => {
                            onPaymentMethodSubmit(stripeEvent, elements);
                          }}
                          expand="block"
                          mode={
                            Capacitor.isNativePlatform()
                              ? Capacitor.getPlatform() == "ios"
                                ? "ios"
                                : "md"
                              : "ios"
                          }
                        >
                          {submitting ? (
                            <IonSpinner
                              className="h-[22px]"
                              name="dots"
                            ></IonSpinner>
                          ) : (
                            "Continue"
                          )}
                        </IonButton>
                      </IonToolbar>
                    </IonFooter>
                  </>
                );
              }}
            </ElementsConsumer>
          </Elements>
        </>
      )}
    </IonPage>
  );
};

export default PLNPlusPaymentMethodPage;
